import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ServerTimePipe } from '../../pipes/server-time.pipe';
import { SharedMaterialUIModule } from '../../modules/shared-material-ui.module';

export type HistoryListEntry = {
  id: string;
  action: string;
  changedDate: string;
  changedBy: string | null;
  description: string | null;
  changedFields?: string | null;
};

@Component({
  selector: 'history-list',
  imports: [DatePipe, ServerTimePipe, ...SharedMaterialUIModule],
  templateUrl: './history-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class HistoryListComponent {
  readonly title = input('Transaction history');
  readonly emptyLabel = input('No history found.');
  readonly history = input<HistoryListEntry[]>([]);
}
